import { useLocation } from "react-router-dom";
import { usePageData } from "@/hooks/usePageData";
import DynamicPage from "@/modules/DynamicPage/DynamicPage";

export default function RoutePlaceholder() {
  const location = useLocation();

  // URL = endpoint diretto (es: /get_page/users/discenti -> get_page/users/discenti)
  const endpoint = location.pathname.slice(1); // rimuove lo slash iniziale

  console.log("RoutePlaceholder - pathname:", location.pathname, "endpoint:", endpoint);

  const { pageData, isLoading, error } = usePageData(endpoint);

  // Mostra loading solo al primo caricamento (quando non ci sono dati)
  // Con keepPreviousData, durante i cambi tab i dati precedenti restano visibili
  if (isLoading && !pageData) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-gray-500">Caricamento...</div>
      </div>
    );
  }

  if (error) {
    console.error("PageData error:", error);
    return (
      <div className="p-4">
        <div className="text-gray-500">route: {location.pathname}</div>
        <div className="text-red-500 text-sm mt-2">Errore: {(error as any)?.message}</div>
      </div>
    );
  }

  if (pageData) {
    return <DynamicPage data={pageData} />;
  }

  return (
    <div className="p-4">
      <div className="text-gray-500">route: {location.pathname}</div>
    </div>
  );
}
